import axios from '@/libs/api.request'
import store from '@/store'

export const getMerchantAlertConfig = () => {
  return axios.request({
    url: 'merchant-alert/admin/config',
    method: 'get',
  })
}

export const saveMerchantAlertConfig = (data) => {
  return axios.request({
    url: 'merchant-alert/admin/config',
    method: 'post',
    data,
  })
}

/** @param {FormData} formData @param {'new_order'|'cancel'} kind */
export const uploadMerchantAlertSound = (formData, kind = 'new_order') => {
  const token = store.getters.token
  const kindNorm = kind === 'cancel' ? 'cancel' : 'new_order'
  // kind 放 query：multer 生成文件名时 body 可能还未就绪
  const params = { kind: kindNorm }
  if (token) params.token = token
  return axios.request({
    url: 'merchant-alert/admin/upload-sound',
    method: 'post',
    data: formData,
    params,
  })
}

export const getMerchantAlertSnapshot = () => {
  return axios.request({
    url: 'merchant-alert/admin/snapshot',
    method: 'post',
    data: {},
  })
}
